import { render, staticRenderFns } from "./CreateNewLifeEvents.vue?vue&type=template&id=94a74346&scoped=true&"
import script from "./CreateNewLifeEvents.vue?vue&type=script&lang=js&"
export * from "./CreateNewLifeEvents.vue?vue&type=script&lang=js&"
import style0 from "./CreateNewLifeEvents.vue?vue&type=style&index=0&id=94a74346&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94a74346",
  null
  
)

export default component.exports